module.exports = __webpack_public_path__ + "img/c04_unitpalintonon_Normal_ua.0ab3ffae.webp";